var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1738 13.5898C13.5458 13.5898 15.4687 11.6669 15.4687 9.29491C15.4687 6.9229 13.5458 5 11.1738 5C8.8018 5 6.87891 6.9229 6.87891 9.29491C6.87891 11.6669 8.8018 13.5898 11.1738 13.5898Z",
    stroke: "#919EAB",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26459 13.903C3.85898 15.2305 3 17.0266 3 19.0048V25.1739H19.3207L19.3467 19.0048C19.3467 17.0786 18.5398 15.3346 17.1862 14.0071C17.1342 13.955 17.1081 13.929 17.0561 13.877",
    stroke: "#919EAB",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1844 11.0582C23.8573 11.0582 25.2135 9.70203 25.2135 8.0291C25.2135 6.35617 23.8573 5 22.1844 5C20.5114 5 19.1553 6.35617 19.1553 8.0291C19.1553 9.70203 20.5114 11.0582 22.1844 11.0582Z",
    stroke: "#919EAB",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1699 20.957H27.9746L28.0006 16.2196C28.0006 14.7359 27.3759 13.3823 26.3347 12.3672",
    stroke: "#919EAB",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/users_icon.d261674d.svg";
export { ForwardRef as ReactComponent };